import regex from '../modules/regex-rules.js';
import { customValidate, customMessages, restrictInput } from '../modules/custom-validation.js';
import { setLoadingState, getAlertHtml, toggleFields, resetForm } from '../modules/form-helpers.js';
import { slideUp, slideDown } from '../modules/animations.js';
import { errorPlacement, highlight, unhighlight, handleFormError } from '../modules/form-validation.js';
import { waitForRecaptcha, showRecaptchaError } from '../modules/functions.js';

document.querySelectorAll('.pv-form').forEach((form) => {
	new toggleFields(form);
});

const $ = window.jQuery;

if (!$ || !$.fn || !$.fn.validate) {
	throw new Error('jQuery sau jQuery Validate nu sunt disponibile.');
}

window.dataLayer = window.dataLayer || [];

class FormPv {
	constructor({ formContainer, formName, formType, formCategory, recaptcha }) {
		this.recaptcha = recaptcha;

		if (!formContainer || !(formContainer instanceof HTMLFormElement)) {
			console.warn(formContainer);
			throw new Error('`formContainer` e undefined sau nu e instanta `HTMLFormElement`.');
		}

		if (!formContainer.dataset.fetchUrl) {
			console.warn(formContainer);
			throw new Error(`#${formContainer.id}: data-fetch-url e undefined.`);
		}

		if (!formName) {
			throw new Error('`formName` e undefined.');
		}

		if (!formType) {
			throw new Error('`formType` e undefined.');
		}

		if (!formCategory) {
			throw new Error('`formCategory` e undefined.');
		}

		this.form = formContainer;

		this.idPrefix = formContainer.dataset.idPrefix || '';

		this.inputErrorContainer = formContainer.querySelector(`#${this.idPrefix}input-error`);

		this.responseContainer = formContainer.querySelector(`#${this.idPrefix}response-message`);
		if (!this.responseContainer) {
			throw new Error(`#${this.idPrefix}response-message e null.`);
		}

		this.inputErrorContainer = this.inputErrorContainer || this.responseContainer;

		this.fetchError = false;
		this.errorType = '';
		this.autoCloseTimer = 10000;

		this.inputContainer = formContainer.querySelector(`#${this.idPrefix}input-section`);
		this.resultsContainer = formContainer.querySelector(`#${this.idPrefix}results-section`);
		this.detailsBtn = formContainer.querySelector(`#${this.idPrefix}details`);
		this.resetBtn = formContainer.querySelector(`#${this.idPrefix}reset-calc`);
		this.paymenPlanSelect = formContainer.querySelector(`#${this.idPrefix}payment-plan`);
		this.brandSelectorContainer = formContainer.querySelector(`#${this.idPrefix}brand-selector`);
		this.brandSelect = formContainer.querySelector(`#${this.idPrefix}brand`);
		this.specsEquipment = formContainer.querySelector(`#${this.idPrefix}specs-equipment`);
		this.specsServices = formContainer.querySelector(`#${this.idPrefix}specs-services`);
		this.brandsData = null;

		this.recaptchaContainer = formContainer.querySelector('.e-recaptcha');
		this.explicitRecaptcha = !!this.recaptchaContainer;

		// dataLayer related
		this.formDescriptor = {
			form_name: formName,
			form_type: formType,
			form_category: formCategory,
			form_url: window.location.href.split('?')[0],
		};

		this.initRecaptcha();
		this.init();
		this.addListeners();
		this.validate();
		this.updateRules();
	}

	initRecaptcha() {
		if (!this.recaptchaContainer) {
			return;
		}

		// Randare explicita recaptcha
		// Pe randare implicita, callback-urile onRecaptchaSuccess si onRecaptchaExpired nu sunt legate
		this.recaptchaWidgetId = this.recaptcha.render(this.recaptchaContainer, {
			sitekey: this.recaptchaContainer.dataset.sitekey,
			// callback: this.onRecaptchaSuccess.bind(this),
			// 'expired-callback': this.onRecaptchaExpired.bind(this),
		});
	}

	init() {
		// Metode custom de validare
		$.validator.addMethod('alpha', customValidate.alpha);
		$.validator.addMethod('alphaNumeric', customValidate.alphaNumeric);
		$.validator.addMethod('phone', customValidate.phone);

		// Restrictionari inputuri
		restrictInput(`#${this.idPrefix}telefon`, regex.digits);
		restrictInput(`#${this.idPrefix}nume`, regex.lettersSpacesHyphens);
		restrictInput(`#${this.idPrefix}localitate`, regex.lettersSpacesHyphensDigits);

		// Conversie uppercase pe codul voucher
		const voucherInput = this.form.querySelector(`#${this.idPrefix}voucher`);
		if (voucherInput) {
			voucherInput.addEventListener('input', () => {
				voucherInput.value = voucherInput.value.trim().toUpperCase();
			});
		}

		// Reguli de validare
		this.rules = {
			nume: {
				required: true,
				alpha: true,
				minlength: 3,
				maxlength: 50,
			},
			judet: {
				required: true,
			},
			localitate: {
				required: true,
				alphaNumeric: true,
				minlength: 3,
				maxlength: 50,
			},
			telefon: {
				required: true,
				phone: true,
			},
			email: {
				required: true,
				email: true,
			},
			consum: {
				required: true,
			},
			bransament: {
				required: true,
			},
			tip_persoana: {
				required: true,
			},
			acord_gdpr: {
				required: true,
			},
		};

		// Mesaje eroare la validare
		this.messages = {
			nume: {
				required: customMessages.required('Nume și prenume'),
				alpha: customMessages.alpha('Nume și prenume'),
				minlength: customMessages.minlength('Nume și prenume'),
				maxlength: customMessages.maxlength('Nume și prenume'),
			},
			judet: {
				required: customMessages.required('Județ'),
			},
			localitate: {
				required: customMessages.required('Localitate'),
				alphaNumeric: customMessages.alphaNumeric('Localitate'),
				minlength: customMessages.minlength('Localitate'),
				maxlength: customMessages.maxlength('Localitate'),
			},
			telefon: {
				required: customMessages.required('Telefon'),
				minlength: customMessages.minlength('Telefon', 10, 'cifre'),
				maxlength: customMessages.maxlength('Telefon', 10, 'cifre'),
				phone: customMessages.phone('Telefon'),
			},
			email: {
				required: customMessages.required('Email'),
				email: customMessages.email('Email'),
			},
			consum: {
				required: customMessages.required('Consum mediu lunar'),
			},
			bransament: {
				required: customMessages.required('Tip branșament'),
			},
			tip_persoana: {
				required: customMessages.radio('Tip persoană'),
			},
			finantare: {
				required: customMessages.radio('Finanțare'),
			},
			stocare: {
				required: customMessages.radio('Stocare'),
			},
			acord_gdpr: {
				required: customMessages.gdpr(),
			},
		};
	}

	async getOfferSimulation() {
		const formData = new FormData(this.form);
		formData.append('action', 'get_offer_simulation');
		formData.append('_wpnonce', formData.get(`${this.form.id}-nonce`));
		formData.delete(`${this.form.id}-nonce`);

		const url = new URL(this.form.dataset.fetchUrl);
		url.searchParams.set('action', 'get_offer_simulation');

		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(Object.fromEntries(formData)),
			});

			const { success, data } = await response.json();

			this.errorType = !success ? 'fetch' : '';

			if (success) {
				this.inputErrorContainer && slideUp(this.inputErrorContainer);
				this.inputContainer && (this.inputContainer.hidden = true);
				this.resultsContainer && (this.resultsContainer.hidden = false);

				const { power, connection, brands } = data.response;
				this.hasStorage = !!data.response.has_storage;
				this.connection = connection;

				// Putere
				this.form.querySelector(`#${this.idPrefix}solution-power`) && (this.form.querySelector(`#${this.idPrefix}solution-power`).textContent = power);

				this.brandsData = brands || {};
				const brandKeys = Object.keys(this.brandsData);

				// Populare dinamica optiuni brand
				if (this.brandSelect) {
					this.brandSelect.innerHTML = '';
					brandKeys.forEach((key) => {
						const option = document.createElement('option');
						option.value = key;
						option.textContent = this.brandsData[key].label || key;
						this.brandSelect.appendChild(option);
					});
				}

				if (brandKeys.length > 1) {
					this.brandSelectorContainer && (this.brandSelectorContainer.hidden = false);
					if (this.brandSelect) {
						this.brandSelect.value = brandKeys[0];
					}
				} else {
					this.brandSelectorContainer && (this.brandSelectorContainer.hidden = true);
					if (this.brandSelect && brandKeys.length === 1) {
						this.brandSelect.value = brandKeys[0];
					}
				}

				const initialBrand = brandKeys[0] ? this.brandsData[brandKeys[0]] : null;
				if (initialBrand) {
					this.updatePaymentOutput(initialBrand.prices);
					this.renderSpecs(initialBrand.specs);
					this.updateSolutionType(initialBrand);
				} else {
					this.updatePaymentOutput(null);
					this.renderSpecs(null);
					this.updateSolutionType(null);
				}
			} else {
				this.inputErrorContainer && (this.inputErrorContainer.innerHTML = getAlertHtml('danger', data.responseTitle || 'Am întâmpinat o eroare', data.response));
				this.inputErrorContainer && slideDown(this.inputErrorContainer);
			}
		} catch (err) {
			this.errorType = 'fetch';
			console.error(err.message);
		}
	}

	renderSpecs(specs) {
		if (this.specsEquipment) {
			this.specsEquipment.innerHTML = '';
			if (specs?.echipamente && Array.isArray(specs.echipamente)) {
				specs.echipamente.forEach((item) => {
					const span = document.createElement('span');
					span.textContent = item;
					this.specsEquipment.appendChild(span);
				});
			}
		}

		if (this.specsServices) {
			this.specsServices.innerHTML = '';
			if (specs?.servicii && Array.isArray(specs.servicii)) {
				specs.servicii.forEach((item) => {
					const span = document.createElement('span');
					span.textContent = item;
					this.specsServices.appendChild(span);
				});
			}
		}
	}

	updateSolutionType(brandData) {
		const solutionType = this.form.querySelector(`#${this.idPrefix}solution-type`);
		if (!solutionType) return;

		if (this.hasStorage && brandData) {
			const storageKwh = brandData.storage_kwh;
			solutionType.textContent = `${this.connection}, cu sistem de stocare de ${storageKwh} kWh`;
		} else {
			solutionType.textContent = this.connection || '';
		}
	}

	formatNumber(value) {
		return new Intl.NumberFormat('ro-RO', {
			maximumFractionDigits: 0,
		}).format(value);
	}

	updatePaymentOutput(prices) {
		const pricesEmpty = !prices || Object.keys(prices).length === 0;

		this.form.querySelector(`#${this.idPrefix}payments-select`) && (this.form.querySelector(`#${this.idPrefix}payments-select`).hidden = pricesEmpty);
		this.form.querySelector(`#${this.idPrefix}pricing-table`) && (this.form.querySelector(`#${this.idPrefix}pricing-table`).hidden = pricesEmpty);

		if (pricesEmpty) {
			return;
		}

		const totalPrice = Number(prices.integral);
		const totalPrice12 = Number(prices['rate-12']);
		const totalPrice24 = Number(prices['rate-24']);
		const totalPrice36 = Number(prices['rate-36']);

		// 3 transe
		const rateOne = totalPrice * 0.3;
		const rateTwo = totalPrice * 0.6;
		const rateThree = totalPrice * 0.1;

		// 12 rate
		const downpayment12 = totalPrice12 * 0.3;
		const monthlyRate12 = (totalPrice12 - downpayment12) / 12;

		// 24 rate
		const downpayment24 = totalPrice24 * 0.3;
		const monthlyRate24 = (totalPrice24 - downpayment24) / 24;

		// 36 rate
		const downpayment36 = totalPrice36 * 0.3;
		const monthlyRate36 = (totalPrice36 - downpayment36) / 36;

		// Plata integrala, valabil si pentru plata in 3 transe
		this.form.querySelector(`#${this.idPrefix}total-price`) && (this.form.querySelector(`#${this.idPrefix}total-price`).textContent = this.formatNumber(totalPrice));
		this.form.querySelector(`#${this.idPrefix}total-price-esalonat`) && (this.form.querySelector(`#${this.idPrefix}total-price-esalonat`).textContent = this.formatNumber(totalPrice));

		// 3 transe
		this.form.querySelector(`#${this.idPrefix}first-rate`) && (this.form.querySelector(`#${this.idPrefix}first-rate`).textContent = this.formatNumber(rateOne));
		this.form.querySelector(`#${this.idPrefix}second-rate`) && (this.form.querySelector(`#${this.idPrefix}second-rate`).textContent = this.formatNumber(rateTwo));
		this.form.querySelector(`#${this.idPrefix}third-rate`) && (this.form.querySelector(`#${this.idPrefix}third-rate`).textContent = this.formatNumber(rateThree));

		// 12 rate
		this.form.querySelector(`#${this.idPrefix}total-price-12`) && (this.form.querySelector(`#${this.idPrefix}total-price-12`).textContent = this.formatNumber(totalPrice12));
		this.form.querySelector(`#${this.idPrefix}downpayment-12`) && (this.form.querySelector(`#${this.idPrefix}downpayment-12`).textContent = this.formatNumber(downpayment12));
		this.form.querySelector(`#${this.idPrefix}monthly-rate-12`) && (this.form.querySelector(`#${this.idPrefix}monthly-rate-12`).textContent = this.formatNumber(monthlyRate12));

		// 24 rate
		this.form.querySelector(`#${this.idPrefix}total-price-24`) && (this.form.querySelector(`#${this.idPrefix}total-price-24`).textContent = this.formatNumber(totalPrice24));
		this.form.querySelector(`#${this.idPrefix}downpayment-24`) && (this.form.querySelector(`#${this.idPrefix}downpayment-24`).textContent = this.formatNumber(downpayment24));
		this.form.querySelector(`#${this.idPrefix}monthly-rate-24`) && (this.form.querySelector(`#${this.idPrefix}monthly-rate-24`).textContent = this.formatNumber(monthlyRate24));

		// 36 rate
		this.form.querySelector(`#${this.idPrefix}total-price-36`) && (this.form.querySelector(`#${this.idPrefix}total-price-36`).textContent = this.formatNumber(totalPrice36));
		this.form.querySelector(`#${this.idPrefix}downpayment-36`) && (this.form.querySelector(`#${this.idPrefix}downpayment-36`).textContent = this.formatNumber(downpayment36));
		this.form.querySelector(`#${this.idPrefix}monthly-rate-36`) && (this.form.querySelector(`#${this.idPrefix}monthly-rate-36`).textContent = this.formatNumber(monthlyRate36));
	}

	addListeners() {
		document.addEventListener('change', this.updateRules.bind(this));

		this.detailsBtn?.addEventListener('click', async (e) => {
			e.preventDefault();

			if ($(this.form).valid()) {
				await this.getOfferSimulation();
				this.form.scrollIntoView({
					behavior: 'smooth',
				});
			}
		});

		this.resetBtn?.addEventListener('click', (e) => {
			e.preventDefault();
			this.resetForm();
		});

		this.form.querySelector(`#${this.idPrefix}new-offer`)?.addEventListener('click', (e) => {
			e.preventDefault();
			this.resetForm();
		});

		// Listener schimbare brand
		this.brandSelect?.addEventListener('change', () => {
			const selectedBrand = this.brandSelect.value;
			const brandData = this.brandsData ? this.brandsData[selectedBrand] : null;

			if (brandData) {
				this.updatePaymentOutput(brandData.prices);
				this.renderSpecs(brandData.specs);
				this.updateSolutionType(brandData);
			}
		});

		// Prevenire submit la Enter in sectiunea de input
		this.inputContainer?.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				e.preventDefault();

				// Trigger validare
				$(this.form).valid();

				// Avansare la pasul 2
				this.detailsBtn?.click();
			}
		});
	}

	updateRules() {
		const $finantare = $('[name="finantare"]');
		const $stocare = $('[name="stocare"]');

		const tipPersoana = document.querySelector('[name="tip_persoana"]:checked')?.value;
		const finantare = document.querySelector('[name="finantare"]:checked')?.value;

		if ($finantare.length) {
			$finantare.rules('remove', 'required');
		}

		if ($stocare.length) {
			$stocare.rules('remove', 'required');
		}

		if (tipPersoana === 'Persoană fizică' && $finantare.length) {
			$finantare.rules('add', 'required');
		}

		if (tipPersoana === 'Persoană juridică' && $stocare.length) {
			$stocare.rules('add', 'required');
		}

		if (finantare === 'Fonduri proprii' && $stocare.length) {
			$stocare.rules('add', 'required');
		}
	}

	resetForm() {
		resetForm(this.form);
		this.errorType = '';
		this.brandsData = null;
		this.hasStorage = false;
		this.connection = '';

		if (this.brandSelect) {
			this.brandSelect.innerHTML = '';
		}
		this.brandSelectorContainer && (this.brandSelectorContainer.hidden = true);
		this.renderSpecs(null);

		this.form.querySelector(`#${this.idPrefix}results-title`) && (this.form.querySelector(`#${this.idPrefix}results-title`).hidden = false);
		this.form.querySelector(`#${this.idPrefix}results-summary`) && (this.form.querySelector(`#${this.idPrefix}results-summary`).hidden = false);
		this.form.querySelector(`#${this.idPrefix}payments-select`) && (this.form.querySelector(`#${this.idPrefix}payments-select`).hidden = false);
		this.form.querySelector(`#${this.idPrefix}pricing-table`) && (this.form.querySelector(`#${this.idPrefix}pricing-table`).hidden = false);
		if (this.explicitRecaptcha) {
			this.recaptchaContainer.hidden = false;
		} else {
			this.form.querySelector(`#${this.idPrefix}recaptcha-container`) && (this.form.querySelector(`#${this.idPrefix}recaptcha-container`).hidden = false);
		}
		slideUp(this.responseContainer);
		this.form.querySelector(`#${this.idPrefix}results-buttons`) && (this.form.querySelector(`#${this.idPrefix}results-buttons`).hidden = false);
		this.form.querySelector(`#${this.idPrefix}thankyou`) && (this.form.querySelector(`#${this.idPrefix}thankyou`).hidden = true);
		this.resultsContainer && (this.resultsContainer.hidden = true);
		if (this.inputContainer) {
			this.inputContainer.hidden = false;
			this.form.scrollIntoView({
				behavior: 'smooth',
			});
		}
	}

	async handleSubmit(form, event) {
		event?.preventDefault();

		const formData = new FormData(form);
		formData.append('action', 'write_panels_lead');
		formData.append('_wpnonce', formData.get(`${this.form.id}-nonce`));
		formData.delete(`${this.form.id}-nonce`);

		const recaptchaPassed = this.explicitRecaptcha ? this.recaptcha.getResponse(this.recaptchaWidgetId) : this.recaptcha.getResponse();

		if (recaptchaPassed) {
			setLoadingState('loading', `${this.idPrefix}submit`, `${this.idPrefix}submitting`);

			const url = new URL(form.dataset.fetchUrl);
			url.searchParams.set('action', 'write_panels_lead');

			try {
				const response = await fetch(url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(Object.fromEntries(formData)),
				});

				const { success, data } = await response.json();

				this.errorType = !success ? 'fetch' : '';

				if (success) {
					this.inputContainer && (this.inputContainer.hidden = true);
					resetForm(form);
					this.errorType = '';

					form.querySelector(`#${this.idPrefix}results-title`) && (form.querySelector(`#${this.idPrefix}results-title`).hidden = true);
					this.brandSelectorContainer && (this.brandSelectorContainer.hidden = true);
					form.querySelector(`#${this.idPrefix}results-summary`) && (form.querySelector(`#${this.idPrefix}results-summary`).hidden = true);
					form.querySelector(`#${this.idPrefix}payments-select`) && (form.querySelector(`#${this.idPrefix}payments-select`).hidden = true);
					form.querySelector(`#${this.idPrefix}pricing-table`) && (form.querySelector(`#${this.idPrefix}pricing-table`).hidden = true);

					if (this.explicitRecaptcha) {
						this.recaptchaContainer.hidden = true;
					} else {
						form.querySelector(`#${this.idPrefix}recaptcha-container`) && (form.querySelector(`#${this.idPrefix}recaptcha-container`).hidden = true);
					}
					slideUp(this.responseContainer);
					form.querySelector(`#${this.idPrefix}results-buttons`) && (form.querySelector(`#${this.idPrefix}results-buttons`).hidden = true);
					form.querySelector(`#${this.idPrefix}thankyou`) && (form.querySelector(`#${this.idPrefix}thankyou`).hidden = false);

					form.scrollIntoView({
						behavior: 'smooth',
					});

					window.dataLayer.push({
						...this.formDescriptor,
						event: 'form_submitted',
						form_details: `Nume: ${formData.get('nume')}`,
						lead: 'Succes',
						phone_number: `+4${formData.get('telefon')}`,
						email: formData.get('email'),
					});
				} else {
					this.responseContainer.innerHTML = getAlertHtml('danger', data.responseTitle || 'Am întâmpinat o eroare', data.response);

					window.dataLayer.push({
						...this.formDescriptor,
						event: 'form_error',
						error_field: data.field,
						error_message: data.response,
					});
				}
			} catch (err) {
				console.error('Fetch error:', err.message);
				this.errorType = 'fetch';
				this.responseContainer.innerHTML = getAlertHtml('danger');
			} finally {
				setLoadingState('', `${this.idPrefix}submit`, `${this.idPrefix}submitting`);
				if (this.explicitRecaptcha) {
					this.recaptcha.reset(this.recaptchaWidgetId);
				} else {
					this.recaptcha.reset();
				}
			}
		} else {
			this.errorType = 'recaptcha';
			this.responseContainer.innerHTML = getAlertHtml('danger', 'Bifează că nu ești robot.', 'Pentru a solicita oferta, e necesar să bifezi reCAPTCHA.');

			window.dataLayer.push({
				...this.formDescriptor,
				event: 'form_error',
				error_field: 'reCaptcha',
				error_message: 'reCaptcha nebifat',
			});

			slideDown(this.responseContainer);
		}
	}

	handleErrors(validator) {
		if (validator.numberOfInvalids() > 0) {
			this.errorType = 'validation';
			this.inputErrorContainer && (this.inputErrorContainer.innerHTML = getAlertHtml('danger', 'Câmpurile marcate cu roșu conțin erori', 'Te rugăm să verifici și să reîncerci.'));
			this.inputErrorContainer && slideDown(this.inputErrorContainer);
		} else {
			if (this.errorType === 'validation') {
				this.errorType = '';
				this.inputErrorContainer && slideUp(this.inputErrorContainer);
			}
		}
		validator.defaultShowErrors();
	}

	validate() {
		const self = this;

		$(this.form).validate({
			focusInvalid: false,
			submitHandler: async function (form, event) {
				await self.handleSubmit(form, event);
			},
			invalidHandler: function (event, validator) {
				handleFormError(event, validator, self.formDescriptor);
			},
			showErrors: function () {
				self.handleErrors(this);
			},
			rules: this.rules,
			messages: this.messages,
			errorPlacement,
			highlight,
			unhighlight,
			errorClass: 'text-danger line-height-1-3 t-centi e-form-error',
		});
	}
}

waitForRecaptcha()
	.then((recaptcha) => {
		recaptcha.ready(() => {
			document.querySelectorAll('.pv-form').forEach((formContainer) => {
				new FormPv({
					formContainer,
					formName: 'PV B2C',
					formType: 'lead',
					formCategory: 'Green',
					recaptcha,
				});
			});
		});
	})
	.catch((err) => {
		console.error(err.message);
		showRecaptchaError('.pv-form');
	});
